.list {
  overflow: auto;
  flex: 1;
  display: flex;
  flex-direction: column;
}
